import { IUserProfileImage } from '../../interfaces';
import { toImageSrc } from '../../utils/imageSrc';
import Text from '../main/Text';
import '../styles/UserProfileImage.css';

function UserProfileImage({ profileImage, name, role, company } : IUserProfileImage)
{
    return (
        <div className = 'user-container'>
            {/* Der Kontrakt liefert seit der Bild-Auslagerung eine URL. `toImageSrc`
                vertraegt beide Formen — ein festes base64-Prefix ergaebe hier
                `data:image/png;base64,/vcard/image/…` und damit ein leeres Bild. */}
            <img src = {toImageSrc(profileImage)} alt = 'Profile'/>
            
            <div className = 'middle-item'>
                <Text text = {name} fontSize = {25} fontWeight = {700}/>
            </div>

            <Text text = {role} fontSize={18} fontWeight={300} />

            {/* Firma unter der Funktion (Spec Firmenname F2) — ohne Wert keine leere Zeile. */}
            {company && <Text text = {company} fontSize={16} fontWeight={300} />}
        </div>
    )
}

export default UserProfileImage;